var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF2539"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97329 17.3816C6.38918 17.3816 5.80506 17.3902 5.22095 17.3773C4.76664 17.3686 4.44646 17.0874 4.48107 16.7066C4.49838 16.5206 4.57194 16.3259 4.6628 16.1614C5.11278 15.348 5.57574 14.5432 6.03438 13.7341C7.56605 11.0386 9.0934 8.34731 10.6251 5.65174C10.8371 5.27531 11.0534 4.89888 11.2654 4.52678C11.2827 4.4965 11.3 4.46621 11.3217 4.43592C11.6981 3.85614 12.2433 3.85181 12.6067 4.44025C12.8577 4.84264 13.074 5.26666 13.3077 5.68203C13.6149 6.2272 13.9264 6.77237 14.2379 7.31754C14.6836 8.09203 14.6879 8.86219 14.2379 9.63668C12.9529 11.865 11.6678 14.0932 10.3784 16.3172C9.96741 17.0225 9.34435 17.3816 8.5266 17.3859C8.01171 17.3859 7.4925 17.3816 6.97329 17.3816Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.362 17.3815C15.6611 17.3815 14.9645 17.3815 14.2635 17.3815C14.177 17.3815 14.0905 17.3815 14.0039 17.3772C13.3289 17.3556 13.0347 16.8623 13.3506 16.2609C13.5583 15.8672 13.7962 15.4864 14.0212 15.1013C14.5794 14.1408 15.1332 13.1803 15.6914 12.2197C15.8298 11.9861 15.9899 11.7697 16.2841 11.7265C16.6649 11.6745 16.8942 11.8909 17.0629 12.1894C17.6038 13.1327 18.1403 14.0802 18.6768 15.0278C18.8888 15.3956 19.1008 15.7677 19.3085 16.1354C19.3475 16.2047 19.3864 16.2739 19.4167 16.3474C19.6547 16.9013 19.3648 17.3642 18.759 17.3729C17.9629 17.3902 17.1625 17.3815 16.362 17.3815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.b18bb717d2cdf5e2a1ee7ab976c02601.svg";
export { ForwardRef as ReactComponent };